import { render } from "./QrCode.vue?vue&type=template&id=41385ac2&scoped=true&ts=true"
import script from "./QrCode.vue?vue&type=script&lang=ts"
export * from "./QrCode.vue?vue&type=script&lang=ts"

import "./QrCode.vue?vue&type=style&index=0&id=41385ac2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41385ac2"]])

export default __exports__